import { AxiosResponse } from "axios";
import { BASE_METHODS } from "../../constants/action-types";

import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import { SuccessDTO } from "../../constants/dto/success";
import {
  removeTeams,
  setTeamActionStart,
  setTeamErrorMessage,
} from "../../constants/reducers/team.reducer";

let body: SuccessDTO;

export const deleteTeams = async () => {
  store.dispatch(setTeamActionStart(true));
  const { selectedIds } = store.getState().team;

  const params = {
    ids: selectedIds,
  };

  const request = await createCall(
    "cms/teams/delete",
    BASE_METHODS.DELETE,
    "application/json",
    "1.0.0",
    params,
    undefined
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(SuccessDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setTeamErrorMessage(TextEnum.DELETE_TEAMS_INVALID_RESPONSE)
      );
      return null;
    }
    store.dispatch(removeTeams());
  } catch (error) {
    store.dispatch(setTeamActionStart(false));
    store.dispatch(timeoutError());
    return null;
  }
};
